import React, { Component } from 'react'
import cn from 'classnames'
import isEqual from 'react-fast-compare'
import { TableBody, TableRow, TableCell } from '@material-ui/core'

import { CarriersSelectCell, SourcesCells } from 'components/BigCalendar/components'

export class BigCalendarBodyBase extends Component {
  state = {
    prevValue: null
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !isEqual(this.props, nextProps) || !isEqual(this.state, nextState)
  }

  componentDidMount() {
    const { subscribeMonthSourcesData, routeId, sources } = this.props

    if (routeId && sources.length) {
      subscribeMonthSourcesData()
    }
  }

  componentDidUpdate(prevProps) {
    const { routeId, date, subscribeMonthSourcesData, sources } = this.props
    const diff = routeId !== prevProps.routeId || date !== prevProps.date || sources !== prevProps.sources

    if (diff && sources.length) {
      subscribeMonthSourcesData()
    }
  }

  onSourceFocus = e => this.setState({ prevValue: +e.target.value })

  onSourceChange = ({ id, sourceId, key }) => e => {
    const { updateMonthSourcesData } = this.props

    const value = +e.target.value

    updateMonthSourcesData({ id, sourceId, key, value })
  }

  onSourceBlur = ({ id, sourceId, key, limit }) => e => {
    const { prevValue } = this.state
    const { setMonthSourcesData } = this.props

    let value = +e.target.value

    if (value < 0) {
      value = 0
    } else if (key === 'booked' && value < prevValue) {
      value = prevValue
    } else if (key === 'booked' && value > limit) {
      value = limit
    }

    const diff = value - prevValue

    setMonthSourcesData({ id, sourceId, key, value, diff })
  }

  renderDateRow = ({ id, totalLimit, totalBookings, day, carrier, sourcesData, tsbwl, tsb, disabled }, i) => {
    const { classes, updateMonthSourcesData, setMonthSourcesData } = this.props

    const isTotalFull = totalBookings === totalLimit
    const highlighted = i % 2 ? classes.highlighted : null

    return (
      <TableRow
        key={id}
        className={cn(classes.dateRow, highlighted, disabled && classes.disabled)}
      >
        <TableCell
          numeric
          scope='row'
          padding='none'
          component='th'
          className={classes.tableCell}
        >
          {day}
        </TableCell>

        <CarriersSelectCell
          id={id}
          onBlur={setMonthSourcesData}
          carrier={carrier}
          classes={classes}
          onChange={updateMonthSourcesData}
        />

        <TableCell
          numeric
          padding='none'
          className={cn(classes.tableCell, tsb === tsbwl && classes.full)}
        >
          {tsb}/ {tsbwl}
        </TableCell>

        <SourcesCells
          id={id}
          date={day}
          onBlur={this.onSourceBlur}
          classes={classes}
          onFocus={this.onSourceFocus}
          onChange={this.onSourceChange}
          sourcesData={sourcesData}
        />

        <TableCell
          numeric
          padding='dense'
          className={isTotalFull ? classes.full : null}
        >
          {totalBookings}/ {totalLimit}
        </TableCell>
      </TableRow>
    )
  }

  render() {
    const { monthSourcesData } = this.props

    return (
      <TableBody>
        {monthSourcesData.map(this.renderDateRow)}
      </TableBody>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/BigCalendar/components/BigCalendarBody/BigCalendarBody.js